import { InputImage, InputText } from '@goodfynd/forms';
import { TextField } from '@mui/material';

import type { UserProfileFormFields, UserProfileFormProps } from './types';

export function UserProfileForm({
  control,
  watch,
}: UserProfileFormProps<UserProfileFormFields>) {
  const email = watch('email');
  return (
    <>
      <InputImage control={control} crop label="Profile image" name="file" />

      <TextField disabled fullWidth label="Email" value={email} />

      <InputText control={control} label="First name" name="firstName" />
      <InputText control={control} label="Last name" name="lastName" />
      <InputText control={control} label="Phone" name="phone" />
      <InputText control={control} label="Postal code" name="postalCode" />
    </>
  );
}
